export { default as withColumns } from '@components/hoc/withColumns/withColumns';



// WEBPACK FOOTER //
// ./src/components/hoc/withColumns/index.ts